import { PD_COLOUR_TABLE_ID } from '@/common/constants';
import { panelColourStringToSvgColourString } from '@/common/colours';
import { metadataServiceInstance } from './metadata-service';

/** A Panel Designer colour table entry, already formatted by the Blazor ColoursService (ColourTableWriter). */
export interface IColourTableEntry {
    id: string;
    name: string;
    component: string | null;
    c: string;
    m: string;
    y: string;
    k: string;
    setInJob: string;
    displayInPanels: string;
}

/**
 * Sets fill/stroke from pe-fill/pe-stroke for every element under the root, so the canvas shows the current
 * spot colour values.
 * @param root The SVG content root.
 */
export function recolourCanvas(root: Element) {
    const update = (el: Element) => {
        if (el.hasAttribute("pe-fill")) {
            el.setAttribute("fill", panelColourStringToSvgColourString(el.getAttribute("pe-fill")));
        }

        if (el.hasAttribute("pe-stroke")) {
            el.setAttribute("stroke", panelColourStringToSvgColourString(el.getAttribute("pe-stroke")));
        }

        for (const child of el.children) {
            update(child);
        }
    };

    update(root);
}

/**
 * Replaces the Panel Designer colour table in the SVG, and removes the XMP swatch groups and Esko inks, which are
 * no longer kept in step with the colour table.
 * @param root The SVG content root.
 * @param entries The colour table entries.
 */
export function writeColourTable(root: SVGSVGElement, entries: IColourTableEntry[]) {
    root.querySelector(`[id="${PD_COLOUR_TABLE_ID}"]`)?.remove();

    const colourTable = document.createElementNS("http://www.w3.org/2000/svg", "metadata");
    colourTable.setAttribute("id", PD_COLOUR_TABLE_ID);

    for (const entry of entries) {
        const spot = document.createElement("spot");
        spot.setAttribute("id", entry.id);
        spot.setAttribute("name", entry.name);
        if (entry.component) {
            spot.setAttribute("component", entry.component);
        }
        spot.setAttribute("c", entry.c);
        spot.setAttribute("m", entry.m);
        spot.setAttribute("y", entry.y);
        spot.setAttribute("k", entry.k);
        spot.setAttribute("set-in-job", entry.setInJob);
        spot.setAttribute("display-in-panels", entry.displayInPanels);
        colourTable.append(spot);
    }

    root.prepend(colourTable);
    metadataServiceInstance.removeSpotColourXmp();
}
